import React, {FC} from "react";
import {css} from "@emotion/react";

import {pointer} from "@pg-design/helpers-css";
import {CloseIcon} from "@pg-design/icons-module";
import {IModalCore, ModalCore} from "@pg-design/modal-module";

const closeButton = (closeModal: (e: React.MouseEvent) => void) => <CloseIcon css={closeButtonStyle} size="2.2" onClick={closeModal} />;

export const RPModal: FC<IModalCore> = (props) => {
    return (
        <ModalCore className={props.className} {...props} overlayStyle={overlayStyle} shouldCloseOnOverlayClick closeButton={props.closeButton || closeButton}>
            {props.children}
        </ModalCore>
    );
};

const overlayStyle = {
    zIndex: 9000,
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
};

const closeButtonStyle = css`
    ${pointer};
    position: absolute;
    top: 2rem;
    right: 2rem;
`;
import React, {FC} from "react";
import {css} from "@emotion/react";

import {pointer} from "@pg-design/helpers-css";
import {CloseIcon} from "@pg-design/icons-module";
import {IModalCore, ModalCore} from "@pg-design/modal-module";

const closeButton = (closeModal: (e: React.MouseEvent) => void) => <CloseIcon css={closeButtonStyle} size="2.2" onClick={closeModal} />;

export const RPModal: FC<IModalCore> = (props) => {
    return (
        <ModalCore className={props.className} {...props} overlayStyle={overlayStyle} shouldCloseOnOverlayClick closeButton={props.closeButton || closeButton}>
            {props.children}
        </ModalCore>
    );
};

const overlayStyle = {
    zIndex: 9000,
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
};

const closeButtonStyle = css`
    ${pointer};
    position: absolute;
    top: 2rem;
    right: 2rem;
`;
